import React from 'react';

import { useIntl } from 'react-intl';

import Config from '../../../config';
import { locales } from '../../../constants';
import { PropTypes } from 'prop-types';

import CustomSwitch from './CustomSwitch';

const { links } = Config;

const LanguageSwitcher = ({ styles, inNavigation }) => {
    const { locale } = useIntl();

    return (
        <div className={styles.container}>
            {locales.map(language => (
                <CustomSwitch
                    key={language}
                    lang={{ label: language.toLocaleUpperCase() }}
                    inNavigation={inNavigation}
                    isCurrent={locale === language}
                    path={links[`${language}Home`]}
                />
            ))}
        </div>
    );
};

LanguageSwitcher.propTypes = {
    styles: PropTypes.shape().isRequired,
    inNavigation: PropTypes.bool.isRequired,
};

export default LanguageSwitcher;
